<template>
  <div class="wordcloud">
    <div class="title">搜索热词</div>
    <div ref="wordcloud" class="wordcloud"></div>
  </div>
</template>

<script>
import echarts from "echarts";
import "echarts-wordcloud/dist/echarts-wordcloud";
import "echarts-wordcloud/dist/echarts-wordcloud.min";
export default {
  data() {
    return {
      key: "",
      wordList: [
        // {
        //   name: "爱上内蒙古",
        //   value: 15000,
        // },
        // {
        //   name: "疫情",
        //   value: 10081,
        // },
        // {
        //   name: "布小林",
        //   value: 9386,
        // },
        // {
        //   name: "旅游",
        //   value: 7500,
        // },
        // {
        //   name: "美食",
        //   value: 7500,
        // },
        // {
        //   name: "脱贫",
        //   value: 6500,
        // },
        // {
        //   name: "走进内蒙古",
        //   value: 6500,
        // },
        // {
        //   name: "扶贫",
        //   value: 6000,
        // },
        // {
        //   name: "环保",
        //   value: 4500,
        // },
        // {
        //   name: "复工",
        //   value: 3800,
        // },
      ],
    };
  },

  methods: {
    // 获取词云图的词
    async gethotWorld() {
      const { data: res } = await this.$http.get(
        "/nmsearch/trssearch/gethotWorld.do",
        {
          params: { siteId: this.searchTag },
        }
      );
      if (res.code == 200) {
        this.wordList = res.result;
      }
      // console.log(this.rank);
    },
    initchart() {
      let myChart = echarts.init(this.$refs.wordcloud);
      myChart.setOption({
        series: [
          {
            cursor: "default",
            type: "wordCloud",
            //用来调整词之间的距离
            // gridSize: 10,
            gridSize: 20,
            //用来调整字的大小范围
            // Text size range which the value in data will be mapped to.
            // Default to have minimum 12px and maximum 60px size.
            // sizeRange: [20, 50],
            sizeRange: [12, 50],
            // shape: "line",
            shape: "pentagon",
            drawOutOfBound: false,
            // Text rotation range and step in degree. Text will be rotated randomly in range [-90,                                                                             90] by rotationStep 45
            //用来调整词的旋转方向，，[0,0]--代表着没有角度，也就是词为水平方向，需要设置角度参考注释内容
            // rotationRange: [-45, 0, 45, 90],
            rotationRange: [0, 0],
            // rotationRange: [-45, 45],
            //随机生成字体颜色
            // maskImage: maskImage,
            textStyle: {
              normal: {
                color: function () {
                  return (
                    "rgb(" +
                    Math.round(Math.random() * 200) +
                    ", " +
                    Math.round(Math.random() * 200) +
                    ", " +
                    Math.round(Math.random() * 200) +
                    ")"
                  );
                },
              },
              emphasis: {
                shadowBlur: 10,
                shadowColor: "#fff",
              },
            },

            //位置相关设置
            // Folllowing left/top/width/height/right/bottom are used for positioning the word cloud
            // Default to be put in the center and has 75% x 80% size.
            left: "center",
            top: "center",
            right: "null",
            bottom: "null",
            width: "95%",
            height: "95%",
            //数据
            data: this.wordList,
          },
        ],
        tooltip: {
          show: false,
          trigger: "item",
          triggerOn: "mousemove|click",
          axisPointer: {
            type: "line",
          },
          showContent: true,
          alwaysShowContent: false,
        },
      });
      // 设置鼠标选中词条时仍显示为箭头
      myChart.getZr().on("mousemove", (param) => {
        var pointInPixel = [param.offsetX, param.offsetY];
        if (myChart.containPixel("grid", pointInPixel)) {
          //若鼠标滑过区域位置在当前图表范围内 鼠标设置为箭头
          myChart.getZr().setCursorStyle("default");
        } else {
          myChart.getZr().setCursorStyle("default");
        }
      });

      // 点击词云
      myChart.on("click", function (params) {});
    },
  },
  watch: {
    key: {
      handler() {
        console.log("change");
      },
    },
    wordList: {
      handler() {
        this.$nextTick(() => {
          this.initchart();
        });
      },
    },
  },
  created() {
    this.gethotWorld();
  },
  mounted() {},
};
</script>
<style lang='less' scoped>
.wordcloud {
  margin-bottom: 40px;
  .title {
    // width: 323px;
    width:100%;
    height: 35px;
    font-size: 18px;
    font-weight: bold;
  }
  .wordcloud {
    // width: 322px;
    width:100%;
    height: 300px;
    /* margin-left: 20px; */
    margin-top: 10px;
    border: 1px solid rgb(230, 230, 230);
  }
}
</style>
